export enum EnumActivityStatus {
  RUNNING = 'running',
  COMPLETED = 'completed',
  FAILED = 'failed',
  INTERRUPTED = 'interrupted',
  CANCELLED = 'cancelled',
  SUPERSEDED = 'superseded'
}
